import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'reply_speed'

export default function ReplySpeedPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How fast do you usually reply?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.replySpeed.heading')}
      buttons={[
        {
          text: t('pages.onboarding.replySpeed.options.rightAway'),
          value: 'rightAway',
        },
        {
          text: t('pages.onboarding.replySpeed.options.fewHours'),
          value: 'fewHours',
        },
        {
          text: t('pages.onboarding.replySpeed.options.onceOrTwice'),
          value: 'onceOrTwice',
        },
        {
          text: t('pages.onboarding.replySpeed.options.wheneverFeel'),
          value: 'wheneverFeel',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
